import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import { recognition } from 'mycorems-app-accounts';
import { Account } from '@/types';
import accountRepository from '../../account-repository';
import SetupCompanyModal from './SetupCompanyModal.vue';
import FreeCreditsModal from '../../client/FreeCreditsModal.vue';
import AccountSettingsModal from '../../../account-settings/AccountSettingsModal.vue';
import GetStartedModal from './GetStartedModal.vue';

export default Vue.extend({
  created() {
    if (!recognition.isCompany()) return;
    const companyId = recognition.getAccountId();
    if (!companyId) return;
    accountRepository.find(companyId).then((client: Account) => {
      if (!client.externalId) {
        const props = { parent: this, accountId: companyId, unclosable: true };
        openModal(SetupCompanyModal, {
          parent: this,
          companyId,
          title: 'Welcome to CM Reports!',
        }).onOk(() => {
          openModal(FreeCreditsModal, { parent: this, client }).onDismiss(() => {
            openModal(AccountSettingsModal, {
              parent: this,
              accountId: companyId,
              title: `Choose report settings for ${client.name}`,
              preamble: 'You can add Report Recipients and modify the settings below at any time under settings.',
            }).onDismiss(() => {
              openModal(GetStartedModal, {});
            });
          });
        });
      }
    });
  },
});
